<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfmf"><a class="xref" href="#/chilie0008#term">Notes on Terminology</a></p>
<p class="tocfm"><a class="xref" href="#/chilie0009#loi">List of Figures</a></p>
<p class="tocfm"><a class="xref" href="#/chilie0010#site">Companion Website</a></p>
<p class="tocf"><a class="xref" href="#/chilie0011#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chilie0012#ch01"><b>1</b>   Making Jazz Manouche</a></p>
<p class="toc"><a class="xref" href="#/chilie0013#ch02"><b>2</b>   Cultural Activism’s Living Legacies</a></p>
<p class="toc"><a class="xref" href="#/chilie0014#ch03"><b>3</b>   Generic Ontologies and the Stakes of Refusal</a></p>
<p class="toc"><a class="xref" href="#/chilie0015#ch04"><b>4</b>   The Sound of Feeling</a></p>
<p class="toc"><a class="xref" href="#/chilie0016#ch05"><b>5</b>   Heritage Stories</a></p>
<p class="toc"><a class="xref" href="#/chilie0017#conc">Conclusion</a></p>
<p class="tocbmf"><a class="xref" href="#/chilie0018#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chilie0019#app1">Appendix 1: Glossary</a></p>
<p class="tocbm"><a class="xref" href="#/chilie0020#app2">Appendix 2: List of Formal Interviews</a></p>
<p class="tocbm"><a class="xref" href="#/chilie0021#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chilie0022#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chilie0023#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lie-0007.vue?a1c9ed48